module.exports = __webpack_public_path__ + "img/male_6.6c6fbd75.png";